import request from "@/common/request";
import { Importacao, ItemDeImportacao, Page } from "@/models";
import { ImportacaoDeNota } from "@/models/ImportacaoDeNota";
import { AxiosRequestConfig } from "axios";

const basePath = '/importacoes'

export const find = async (params?: any, config?: AxiosRequestConfig): Promise<Page<Importacao>> => 
	request.get(`${basePath}`, { params, ...config })

export const findItens = (params?: any, config?: AxiosRequestConfig): Promise<Page<ItemDeImportacao>> =>
	request.get(`${basePath}/itens`, { params, ...config })

export const findAllItens = (params?: any, config?: AxiosRequestConfig): Promise<ItemDeImportacao[]> =>
	request.get(`${basePath}/itens/listagem`, { params, ...config })

export const baixarXmls = (idImportacao: string, config?: AxiosRequestConfig) =>
	request.get(`${basePath}/${idImportacao}/xmls`, {
		...config,
	});

export const podeGerarDownloadCompleto = (lojaId: string, config?: AxiosRequestConfig) => 
	request.get(`${basePath}/pode-gerar-xml-completo/${lojaId}`, {
		...config,
	});

export const possuiImportacoesEmAbertoNoUsuarioLogado = (usuarioId: string, config?: AxiosRequestConfig) => 
	request.get(`${basePath}/possui-importacoes-em-aberto/${usuarioId}`, {
		...config,
	});	